import React from "react";
import { useRouter } from "next/navigation";

interface Props {
  data: any;
}
const BlogSuccess: React.FC<Props> = ({ data }) => {
  const router = useRouter();
  return (
    <>
      <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white before:content-[''] before:absolute before:h-[100%] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-10">
        <div className="container">
          <div className="heading mb-[40px] lg:mb-[40px] xl:mb-[56px]">
          <h2 className="text-[32px] leading-[41.6px] md:text-[48px] md:leading-[62.4px] xl:text-[56px] xl:leading-[72.8px] font-[700] text-primary-text text-center">
              {data.title}
            </h2>
          </div>
          <div className="flex items-center justify-center">
            <button
              type="button"
              aria-label="Contact us"
              onClick={() => router.push(data?.buttons?.[0]?.link?.href ?? "#")}
              className="flex items-center justify-center gap-2.5 font-semibold transition-all duration-300 group
              bg-[#0086E6] hover:bg-blue-700 cursor-pointer text-white
              my-0 xl:text-subtitle-3 whitespace-nowrap lg:text-subtitle-4 px-8 xl:pt-[14px] xl:pb-[12px] pt-[11px] pb-[9px] text-subtitle-3 tracking-wider"
            >
              {data?.buttons?.[0]?.link?.label ?? "Book Consultation"}
              <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="my-[3px] flex-[0_0_auto]"
                    >
                      <path
                        d="M1.25 9.6582H17.75"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                        className="group-hover:opacity-100 opacity-0  transition-all duration-300"
                      ></path>
                      <path
                        d="M11.5908 2.5L18.7499 9.65909L11.5908 16.8181"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                        className="group-hover:translate-x-0 -translate-x-[3px] -translate-x-0 transition-all duration-300"
                      ></path>
                    </svg>
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogSuccess;
